(function () {
    'use strict';

    if (typeof window === 'undefined') {

        metricsAggregates(
            module.exports,
            require('../../../enums/metrics.js'),
            require('../../../enums/metrics.js'),
            require('lodash')
        );

    } else {
        RivalIQ.module('models.metrics');

        metricsAggregates(
            RivalIQ.models.metrics,
            RivalIQ.enums,
            RivalIQ.enums.timeAnalysisMode,
            window._
        );
    }

    function metricsAggregates(metrics, metricEnums, timeAnalysisModes, _) {

        const aggregates = {
            average: {
                value: function avgFn(metric, submetric) {
                    metric.over.data = submetric;
                    const data = metric.over.getValue({
                        format: false
                    });

                    if (!data || !data.length) {
                        return undefined;
                    }

                    return _.sumBy(data, _.last) / data.length;
                },
                description: _.identity,
                format: function (data, metric, options) {
                    const metricType = metric.getType();

                    if (metric.getTimeAnalysisMode() === timeAnalysisModes.DELTA_RELATIVE) {
                        return RivalIQ.formatter.formats.percent(data);
                    } else if (metricType === metricEnums.dataType.ABSOLUTE_PERCENT) {
                        return RivalIQ.formatter.absolutePercent(data);
                    } else if (metricType === metricEnums.dataType.INTEGER) {

                        const expanded = _.get(options, ['expand']);
                        if (data > 100) {
                            data = Math.round(data);

                            if (expanded) {
                                return RivalIQ.formatter.formats.number(data);
                            }
                        }

                        return RivalIQ.formatter.formatAbbreviated(data, null, {
                            decimals: 2,
                            trailingZeros: false
                        });
                    } else {
                        return RivalIQ.metric.format.formatFn(metric.attributes, data, options)(data);
                    }
                }
            },

            max: {
                name: function (name) {
                    return `Max ${name}`;
                },
                description: _.identity,
                value: function (metric, submetric) {
                    metric.over.data = submetric;
                    const data = metric.over.getValue({
                        format: false
                    });

                    const bucket = _.maxBy(data, _.last);

                    return metric.get('returns') === 'name' ? _.head(bucket) : _.last(bucket);
                }
            }
        };

        metrics.aggregate = function (metric, submetric, method) {
            return aggregates[method].value(metric, submetric);
        };

        metrics.getAggregate = function (metric, key, data, options) {
            const fn = _.get(aggregates, [metric.get('aggregate'), key], _.noop);
            return fn(data, metric, options);
        };
    }
})();
